import React from "react";
import { useLocation } from "react-router-dom";
import CreateEvent from "../components/events/CreateEvent";

export default function CreateEventPage({ user }) {
	const location = useLocation();
	const copiedEvent = location.state?.copiedEvent || null;

	return <CreateEvent user={user} copiedEvent={copiedEvent} />;
}
